import { faDisplay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface ShareScreenButtonProps {
  shared: boolean;
  onToggle: () => void;
}

const ShareScreenButton: React.FC<ShareScreenButtonProps> = ({
  shared,
  onToggle,
}) => (
  <button
    onClick={onToggle}
    className={`w-14 h-14 text-white text-xl rounded-2xl transition flex justify-center align-middle items-center ${
      shared ? "bg-[#555] hover:bg-[#666]" : "bg-[#7E57C2] hover:bg-[#6846a1]"
    }`}
  >
    {shared ? (
      <FontAwesomeIcon icon={faDisplay} />
    ) : (
      <FontAwesomeIcon icon={faDisplay} />
    )}
  </button>
);

export default ShareScreenButton;
